import { createSelector } from '@reduxjs/toolkit'
import _ from 'lodash'
import { selectExport } from './selectForm'
import { AuditIndication, Import } from '@fusion-advantage/backcompat'
import { importDateNow, LeaveBehindConcept, isConceptStatus, cidForDirItemId, getConceptStatusValue } from '@fusion-advantage/formlib'
import { FormRootState } from './formStore'
import { selectLabMaterialClaims } from './labsSlice'

const cidUrgentEmergentIssue = cidForDirItemId(469)

const selectDbImport = createSelector(
	(state: FormRootState) => state.render.authedIdentity?.upn,
	(state: FormRootState) => selectExport(state)?.Form.Encounter,
	(state: FormRootState) => state.form.conceptStatus,
	(state: FormRootState) => state.form.statusHistory,
	(state: FormRootState) => state.form.calculationErrors,
	selectLabMaterialClaims,
	(userId, encounter, conceptStatuses, statusHistory, calculationErrors, labMaterialClaims): Import|null => {
		if(!encounter?.Encounter_GUID) {
			return null
		}
		const dbImport: Import = {
			FormResponse: {
				Encounter: {
					SubmittingUserID: userId,
					...importDateNow(),
					Encounter_GUID: encounter.Encounter_GUID,
					LeaveBehindCode: null,
					IndicatedAudit: [],
					MaterialClaims: [...labMaterialClaims],
				},
				ConceptStatuses: Object.values(conceptStatuses),
				StatusHistory: statusHistory,
			},
		}
		if(encounter.DisplayWarnings) {
			dbImport.FormResponse.CalculationEngineErrors = calculationErrors
		}
		const leaveBehindStatus = conceptStatuses[LeaveBehindConcept.cid]
		if(isConceptStatus(leaveBehindStatus) && _.isString(leaveBehindStatus.value)) {
			dbImport.FormResponse.Encounter.LeaveBehindCode = leaveBehindStatus.value
		}
		if(getConceptStatusValue(conceptStatuses[cidUrgentEmergentIssue]) === true) {
			dbImport.FormResponse.Encounter.IndicatedAudit.push({Indication: AuditIndication.Urgent})
		}
		return dbImport
	}
)

export default selectDbImport
